import { PaginatedDataStore } from '../../../ng-services/paginated-data.store';
import { IPromise } from 'angular';

export class NextPageObserverComponent {
    static $inject = ['$element', '$interval'];

    paginatedStore!: PaginatedDataStore<any, any>;

    private observer!: IntersectionObserver;

    isIntersecting: boolean = false;
    updateInterval!: IPromise<any>;

    constructor(private $element: ng.IRootElementService, private $interval: ng.IIntervalService) {}

    $onInit() {
        const target = this.$element[0];

        this.observer = new IntersectionObserver((c) => {
            // monitor intersection state
            this.isIntersecting = c[0].isIntersecting;
        });

        this.updateInterval = this.$interval(() => this.update(), 100);

        this.observer.observe(target);
    }

    update() {
        if (!this.isIntersecting) {
            // observer not visible
            // we shouldn't load any more items now
            return;
        }

        // observer is visible
        // we should load pages until it's not visible

        if (this.paginatedStore.isLoading) {
            return;
        }

        if (!this.paginatedStore.hasNextPage) {
            return;
        }

        this.paginatedStore.loadNextPage();
    }

    $onDestroy() {
        this.$interval.cancel(this.updateInterval);
        this.observer.disconnect();
    }
}

angular.module('tradersyard').component('tyNextPageObserver', {
    // language=HTML
    template: `
        <div class="next_page_observer" mobx-autorun>
            <ty-loading-spinner ng-if="$ctrl.paginatedStore.hasNextPage && $ctrl.paginatedStore.isLoading"/>
        </div>
    `,
    bindings: {
        paginatedStore: '<',
    },
    controller: NextPageObserverComponent,
});
